const pdf = [
    {
        id: 0,
        title: '2023-2024 Impact Report',
        url: 'pdfs/2023-2024-Impact-Report.pdf'
    },

]

export default pdf;